import React from 'react';
import '../styles/Platforms.css';

const PLATFORMS = [
  'Fiverr',
  'Upwork',
  'Freelancer',
  'LinkedIn',
  'Github',
  'Gitlab'
];

const Platforms = () => {
  return (
    <section className="platforms section" aria-labelledby="platforms-title">
      <div className="container">
        <h2 id="platforms-title" className="platforms-title">
          Featured on Trusted Platforms
        </h2>
        <div className="platforms-marquee" aria-hidden="true">
          <div className="platforms-track">
            {[...PLATFORMS, ...PLATFORMS].map((name, i) => (
              <span key={`${name}-${i}`} className="platforms-item">
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Platforms;
